/**
 * 展示层格式化工具
 */

/**
 * 格式化价格用于展示（统一半角 ¥）。
 *
 * 背景（2026-10-21）：闲鱼商品卡片的 priceInfo 是 {preText: '¥', price: '3.88'}，
 * 采集端历史实现把 preText 直接拼进 item_info.item_price，库里存成了「¥3.88」；
 * 而卡片模板自己还会补一个「¥」，于是页面显示成「¥¥3.88」。
 *
 * 这里做兜底：已经带符号的值先剥掉再统一补一个，既修复存量脏数据，
 * 也不需要动数据库。纯文本价格（如「面议」「价格未知」）原样返回，不强行加符号。
 */
export const formatPrice = (value?: string | number | null): string => {
  if (value === undefined || value === null) return '-';
  const text = String(value).trim();
  if (!text) return '-';
  if (/^[¥￥]/.test(text)) {
    return `¥${text.replace(/^[¥￥]\s*/, '')}`;
  }
  if (/^\d/.test(text)) {
    return `¥${text}`;
  }
  return text;
};

/**
 * 闲鱼图床缩略图：把 `_720x720q90.jpg` 这类缩放后缀换成目标尺寸。
 *
 * 背景（ITM-005，2026-11-05）：订单列表一格只有 56px，却拉 720x720 大图，
 * 一页 10 行 = 10 张大图，移动网络首屏明显变慢。阿里云图床支持在 URL 上
 * 直接改缩放参数，无需另存小图。
 *
 * 规则：匹配结尾的 `_宽x高q质量.扩展名` 整段替换；不带缩放后缀的地址原样返回
 * （避免破坏无后缀的 CDN 链接）。列表用 200，详情弹窗传大尺寸或不传（用原图）。
 */
export const thumbImage = (url?: string | null, size = 200): string => {
  if (!url) return '';
  return String(url).replace(/_\d+x\d+q\d+(\.(?:jpg|jpeg|png|webp))$/i, `_${size}x${size}q90$1`);
};
